export const MODULE_TYPE = {
  TASK: "TASK",
  WORKSHOP: "CHAPTER"
};
